<template>
  <div>
    <custom-callout
      class="mb-3 custom-callout"
      :opened="isPanelOpen"
      :controlled="true"
      :border-color="getStatus.statusColor"
      @click:open="onToggle()"
    >
      <div class="row py-3">
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Estatus:
          </div>
          <div class="color-black font-16 font-weight-normal">
            <custom-balloon
              :background-color="getStatus.statusColor"
              class="mt-2"
              :text="getStatus.statusName"
              dot
            />
          </div>
        </div>
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Nombre de Equipo:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.name | empty }}
          </div>
        </div>
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Cantidad en Inventario:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.quantity | empty }}
          </div>
        </div>
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Disponible en Inventario:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.availableQuantitiy }}
          </div>
        </div>
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Última Fecha de Inventario:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.lastDate | date }}
          </div>
        </div>
        <div class="col">
          <drop-down
            always-show-dropdown
            :items="actionItems"
            class="float-md-right mr-5"
          />
        </div>
      </div>
      <div class="col-12 border-bottom"></div>
      <div class="row py-3">
        <div
          class="col-md-2 col-12 col-spacing mb-3 mb-lg-0"
          v-for="(property, key) in item.properties"
          :key="key"
        >
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            {{ property.id }}:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ property.name }}
          </div>
        </div>
      </div>
      <template #edition>
        <div class="py-4 px-5">
          <div class="mb-3 font-weight-bold">
            <i class="fas fa-info-circle text-orange mr-2"></i>
            Descripción del Equipo
          </div>

          <div class="d-flex flex-column gap-y-2">
            <div>
              <div class="color-secondary-6 font-14">
                Descripción del Equipo:
              </div>
              <div>
                {{ item.description | empty }}
              </div>
            </div>
            <div>
              <div class="color-secondary-6 font-14">
                Datos de Ubicación/Dirección:
              </div>
              <div>
                {{ item.address | empty }}
              </div>
            </div>
          </div>
          <div v-if="item.accessories.length > 0" class="pt-4 row ml-0">
            <div class="col-12 mb-4 pl-0">
              <div class="color-secondary-6 font-14">
                Accesorio(s) Seleccionado(s):
              </div>
            </div>
            <div
              class="col-12 col-lg-3 bg-white rounded d-flex justify-content-between p-3 mr-2"
              v-for="(accessory, index) in item.accessories"
              :key="index"
            >
              <div>
                <p class="font-16 font-weight-bold mb-0">
                  {{ accessory.id }}
                </p>
                <p class="font-14 mb-0">
                  <span class="text-muted">
                    {{ accessory.name }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import CustomBalloon from 'custom-balloon';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import mixAlert from '@/mixins/alert.mixin';

const TEMPLATE_TAB_INDEX = {
  EQUIPMENTINFO: 1,
};
export default {
  name: 'InventoryManagementResultRowSummary',
  components: {
    CustomCallout,
    DropDown,
    CustomBalloon,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedTemplateTabIndex: null,
      accesories: [],
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    getStatus() {
      return this.item.availableQuantitiy > 0
        ? { statusColor: '#A3E5B3', statusName: 'Disponible' }
        : { statusColor: '#D5B89A', statusName: 'No Disponible' };
    },
    actionItems() {
      return [
        {
          name: 'Descripción del Equipo',
          icon: 'fas fa-info-circle text-green',
          click: async () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.EQUIPMENTINFO;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Agregar Inventario',
          icon: 'fas fa-edit text-green',
          click: () => {
            this.$router.push({
              name: 'inventoryMaintenanceEquipmentAddInventory',
              params: {
                id: this.catalogId,
                equipmentId: this.item.key,
              },
            });
          },
        },
      ];
    },
    isPanelOpen() {
      return this.item.isOpen;
    },
    catalogId() {
      return this.$route.params.id;
    },
  },
  methods: {
    async onToggle() {
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.EQUIPMENTINFO;

      if (this.item.isOpen) {
        this.$emit('close', this.item);
        return;
      }

      this.$emit('open', this.item);
    },
  },
};
</script>
<style lang="scss" scoped>
.gap-y-2 {
  gap: 20px 0px;
}

.bg-white {
  ::v-deep div.bg-secondary-3 {
    background-color: white !important;
  }
}

::v-deep .dot {
  padding: 18px !important;
  margin-bottom: 1px;
}

::v-deep .title-icon {
  padding-bottom: 3px;
}
</style>
